import {
  LOGO_PROJECTTION,
  compatibleImageProjection,
  computedInternalUrl,
  internalReferenceUrl,
} from './projection';
import { namespaceType } from '../lib/namespace';

const headerType = namespaceType('header');
const navigationItemLevel1Type = namespaceType('navigationItemLevel1');
const navigationItemLevel3Type = namespaceType('navigationItemLevel3');

export const internalReference = (field = 'internalReference') => `
  ${field}->{
    _id,
    _type,
    name,
    "url": ${computedInternalUrl}
  }
`;

const buildInternalReferenceUrl = (computedUrl: string) => `
  select(
    type == "internal" && defined(internalReference) =>
      internalReference->{
        "computedUrl": ${computedUrl}
      }.computedUrl,
    url
  )
`;

const buildInternalReference = (computedUrl: string, field = 'internalReference') => `
  ${field}->{
    _id,
    _type,
    name,
    "url": ${computedUrl}
  }
`;

export const createHeaderMegaMenuQuery = (
  customComputedInternalUrl: string,
  logoProjection: string,
) => {
  const refUrl = buildInternalReferenceUrl(customComputedInternalUrl);
  const ref = (field = 'internalReference') => buildInternalReference(customComputedInternalUrl, field);

  const buttonProjection = `
    _key,
    label,
    isActive,
    style,
    "link": link {
      ...,
      "type": type,
      "url": ${refUrl},
      "isOpenInNewTab": coalesce(isOpenInNewTab, newTab),
      ${ref()}
    }
  `;

  return `
    *[_type == "${headerType}"][0] {

      "headerLogo": ${logoProjection},

      "navigationItems": megaMenuNavigationItems[] {
        _type == "${navigationItemLevel1Type}" => {
          ...,
          "navigationType": "level1",
          "label": title,
          link {
            ...,
            ${ref()}
          },
          advertisingBanner {
            ...,
            ${compatibleImageProjection('image', 'advertisingBannerImage', 'bynderAdvertisingBannerImage')},
            bynderAdvertisingBannerImage,
            isEnabled,
            "label": text,
            link {
              "type": link.type,
              "href": ${refUrl},
              "isOpenInNewTab": coalesce(link.isOpenInNewTab, link.newTab)
            }
          },
          "childrenColumn": select(
            layoutType == "column" => childrenColumn[] {
              ...,
              "navigationType": "level2Column",
              "label": title,
              link {
                ...,
                ${ref()}
              },
              "childrenColumn": children[] {
                _type == "${navigationItemLevel3Type}" => {
                  ...,
                  "navigationType": "level3",
                  "label": title,
                  link {
                    ...,
                    ${ref()}
                  }
                }
              }
            }
          ),
          "childrenGrid": select(
            layoutType == "grid" => childrenGrid[] {
              ...,
              "navigationType": "level2Grid",
              link {
                ...,
                ${ref()}
              },
              "label": title,
              description,
              ${compatibleImageProjection('thumbnail', 'thumbnail', 'bynderThumbnail')},
              bynderThumbnail
            }
          )
        }
      },

      "primaryButton": buttons[isActive == true && style == "primary"][0] {
        ${buttonProjection}
      },

      "secondaryButton": buttons[isActive == true && style == "secondary"][0] {
        ${buttonProjection}
      },

      "buttons": buttons[isActive == true] {
        ${buttonProjection}
      }
    }
  `;
};

export const HEADER_MEGA_MENU_QUERY = createHeaderMegaMenuQuery(computedInternalUrl, LOGO_PROJECTTION);
